import { z } from 'zod';
import { SalesOrderShortfallResolution } from '../../constants/sales-order-shortfall-resolution.js';
import { requiredUuidString } from '../zod-helpers/index.js';
const CHOICE_REQUIRED = 'Choose what happens if this line is short.';
// null is "Decide at shipment", so an omitted choice is refused rather than clearing one.
export const setSalesOrderItemShortfallResolutionInputSchema = z.object({
    salesOrderItemId: requiredUuidString('Sales order line is required.', 'Invalid sales order line selection.'),
    resolutionId: z.enum(SalesOrderShortfallResolution, CHOICE_REQUIRED).nullable(),
});
//# sourceMappingURL=set-sales-order-item-shortfall-resolution-input.js.map